// extracted by mini-css-extract-plugin
export var backgroundMove = "hero-module--backgroundMove--2Og2O";
export var hero = "hero-module--hero--2U58p";
export var heroLine = "hero-module--heroLine--1KU5z";
export var heroName = "hero-module--heroName--3qtSu";